class Forms {
    forms = null;
    
    constructor(forms) {
        this.forms = forms;
    }
    
    submitButton() {
        // Loop over them and prevent submission
        Array.prototype.filter.call(this.forms, function(form) {
            form.addEventListener('submit', function(event) {
                if (form.checkValidity()) {
                    let submitting = event.submitter.querySelector('[data-submitting-text]');
                    let submitText = event.submitter.querySelector('[data-submit-text]');
                    if (submitting) submitting.classList.remove('d-none');
                    if (submitText && submitting) submitText.classList.add('d-none');
                }
            }, false);
        });
        
        return this;
    }
    
    validate() {
        // Loop over them and prevent submission
        Array.prototype.slice.call(this.forms)
        .forEach(function (form) {
            form.addEventListener('submit', function (event) {
                if (!form.checkValidity()) {
                    event.preventDefault()
                    event.stopPropagation()
                }
                
                form.classList.add('was-validated')
            }, false)
        });

        return this;
    }
}

export default Forms;